<template>
  <div class="lookup-relationship-box">
    <div class="lookup-select">
      <FilterSelect
        style="flex: 1;"
        v-bind="$attrs"
        filterable
        clearable
        :placeholder="placeholder"
        :disabled="disabled"
        :size="size"
        :model="value"
        :keys="selectKeys"
        :options="mainFieldList"
        @change="selectChange"
      />
      <i
        v-if="showAddIcon"
        class="icon el-icon-plus"
        :class="`icon-size-${size}`"
        @click="clickShowTable"
      />
    </div>
    <sy-popup
      class="lookup-relationship-popup"
      v-model="dialogTableVisible"
      :title="pageText.chooseData"
      size='large'
    >
      <render :viewContent="tabSchema.nodes"/>
       <template slot="footer">
        <el-button @click="dialogTableVisible = false">{{pageText.cancel}}</el-button>
        <el-button type="primary" @click="submit">{{pageText.confirm}}</el-button>
      </template>
    </sy-popup>
  </div>
</template>

<script>
  import { lookupRelationshipProps } from '../index.js'
  import {HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'
  import i18n from '../i18n.js'
  import { requestValueObject, requestFetchData, requestLookUpRelationLayout } from '../request.js'
  import {initSchema, interfacesHandle, processAbility} from '../../../../utils/share'
  import {childVm} from '../../../../utils/emitter'
  import {assign, cloneDeep} from 'lodash-es'
  import cachedRequest from '../../../../../../../utils/cached-request'
  import FilterSelect from '../../../../../../basis/filter-select'

  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'edit-lookup-relationship',
    components: {FilterSelect},
    provide () {
      return {
        formData: this.list,
        subData: null,
        store: {
          queryParams: this.paginationParam,
          _search: this._search,
          _changePage: this._changePage
        }
      }
    },
    inject: ['formData'],
    props: lookupRelationshipProps,
    data () {
      return {
        // 是否显示 Dialog
        dialogTableVisible: false,
        tabSchema: {},
        pageText,
        mainFieldList: [],
        selectRow: {},
        paginationParam: {
          page: 1,
          pageSize: 10,
          total: 0,
          pageSizes: [10, 20, 30, 40, 50],
          conditionList: {}
        },
        // 值数据
        list: [],
        tableData: [],
        allLanguageData: {}
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    watch: {
      // table变化设置 list
      tableData (val) {
        this.list.splice(0, this.list.length)
        val.forEach((item, index) => {
          this.$set(this.list, index, item)
        })
      }
    },
    computed: {
      headerParams () {
        const {relateObjectApiName, layoutApiName} = this.params
        return {
          [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
          [HEADER_PARAMS_KEYS.layoutApiName]: layoutApiName,
          [HEADER_PARAMS_KEYS.objectApiName]: relateObjectApiName
        }
      },
      tableRef () {
        return childVm.call(this, 'table')
      },
      uniqueKey () {
        return this.abilityResponseParams?.uniqueKey
      },
      selectKeys () {
        return {
          valueKey: this.uniqueKey,
          labelKey: this.abilityResponseParams?.contentKey,
          optionsValueKey: this.uniqueKey,
          optionsLabelKey: this.abilityResponseParams?.contentKey
        }
      }
    },
    mounted () {
      this.getValueObject()
    },
    methods: {
      selectChange (key, option) {
        let _option = {}
        if (option) {
          _option = option
        }
        this.$emit('change', cloneDeep(_option))
      },
      async clickShowTable () {
        await this.getLookUpRelationLayout()
        this.fetchData()
        this.dialogTableVisible = true
      },
      selectionChange (row = []) {
        this.selectRow = row[0]
      },
      submit () {
        const value = this.selectRow
        if (value) {
          this.$emit('change', value)
        }
        this.dialogTableVisible = false
      },
      // 获取值对象
      async getValueObject () {
        if (!this.interfacesGetList) {
          console.log(`未配置能力: ${this.params.apiName}当前查找关联字段-列表接口`)
          return
        }

        try {
          const {interfaces, params} = interfacesHandle(this.interfacesGetList, this.formData)
          this.mainFieldList = await requestValueObject(
            {
              ...interfaces,
              params
            },
            this.headerParams
          )
        } catch(e) {
          console.log('能力接口异常:', e)
          console.log('异常能力接口配置:', this.interfacesGetList)
        }
      },
      _search () {
        this.fetchData()
      },
      _changePage (page) {
        assign(this.paginationParam, page)
        this.fetchData()
      },
      // 查询值能力接口
      async getRowValue (row) {
        const uniqueKey = this.interfacesGetValue?.requestParams?.uniqueKey
        if (!row[uniqueKey]) {
          return row
        }
        const {interfaces: {url, type}} = interfacesHandle(this.interfacesGetValue, row)
        const {content, isOk} = await cachedRequest(
          {type, url},
          {
            [uniqueKey]: row[uniqueKey]
          },
          false,
          {
            authError: false
          },
          this.headerParams
        )

        if (isOk) {
          return content
        }
      },
      // 获取值数据
      async fetchData () {
        const {tenantType, relateObjectApiName, objectApiName, _objectApiName, apiName} = this.params
        const params = {
          apiName,
          tenantType,
          relateObjectApiName,
          objectApiName: _objectApiName || objectApiName,
          tabApiName: this.tabSchema?.info?.apiName,
          ...this.paginationParam,
          conditionList: Object.values(this.paginationParam.conditionList).filter(v => {
            if (Array.isArray(v?.value)) {
              return v?.value.some(v => v)
            }
            return v?.value
          })
        }
        const data = await requestFetchData(params, {
          [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
          [HEADER_PARAMS_KEYS.objectApiName]: relateObjectApiName
        })

        if (data) {
          this.tableData = data.content
          this.$set(this.paginationParam, 'total', data.count)
          this.$nextTick(() => {
            this.tableRef?.toggleSelection && this.tableRef.toggleSelection(
              this.tableData.filter(v => v[this.uniqueKey] === this.value[this.uniqueKey]),
              true
            )
          })
        }
      },
      // 获取从对象布局信息
      async getLookUpRelationLayout () {
        const params = {
          tenantType: this.params.tenantType,
          oneObjectApiName: this.params.relateObjectApiName,
          listLayoutApiName: this.params.listLayoutApiName
        }
        const content = await requestLookUpRelationLayout(params, this.headerParams)
        // 能力处理
        await processAbility(content)
        // todo 需要修改
        this.tabSchema = await initSchema({schema: content}, {
          config: {
            [this.params.relateObjectApiName]: {
              table: {
                props: {
                  showSelection: true,
                  showListButton: false,
                  showRowButton: false,
                  selectType: 'radio',
                  rowKey: 'aPaaS_SequenceId',
                  selectionChange: this.selectionChange.bind(this)
                }
              }
            }
          },
          isForm: false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .lookup-relationship-popup {
    ::v-deep .list-search {
      border: 1px solid #D6DFFF !important;
      border-radius: 8px !important;
      box-shadow: 0 0 8px rgba(57, 121, 201, 0.14) !important;
    }
  }

  .lookup-relationship-box {
    display: inline-block;
    width: 100%;
  }

  .lookup-select {
    display: flex;
    align-items: center;
    height: 32px;

    .icon {
      font-size: 18px;
      font-weight: 600;
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }

    .icon-size-mini {
      font-size: 14px;
      width: 30px;
      height: 30px;
      line-height: 30px;
    }
  }
</style>
